<template>
  <section
    class="listing-come-funziona">
    <ul :class="{'listing-come-funziona--noTouch': !touch}">
      <li
        v-for="(section, index) of list"
        v-animate-on-intersection
        :key="index">
        <router-link :to="{ name: `${lang}-come-funziona-sub`, params: { type: section.slug } }">
          <picture v-if="section.coverDesk">
            <source :srcset="section.coverMobile && section.coverMobile.responsiveImage ? section.coverMobile.responsiveImage.src : section.coverDesk.responsiveImage.src" media="(max-width: 639px)">
            <source :srcset="section.coverDesk.responsiveImage.src" media="(min-width: 640px)">
            <img :src="section.coverDesk.responsiveImage.src" :alt="section.title">
          </picture>
          <div class="velina-come-funziona">
            <img src="/come-funziona/hover-poligono-page.png">
          </div>
          <div class="default-container">
            <div class="listing-come-funziona__text-container">
              <img
                :src="`/come-funziona/${index + 1}.svg`"
                class="number"
              />
              <div>
                <h3 v-html="section.titolo" class="text-to-uppercase" />
                <p v-html="section && section.abstract !== '' ? section.abstract.replace(/\n/g, '<br> '): ''"/>
                <div class="arrow-list-wrapper hide-to-medium">
      <svg id="Icon_feather-arrow-right" data-name="Icon feather-arrow-right" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
        <path id="Unione_1" data-name="Unione 1" d="M10.793,22.708a1,1,0,0,1,0-1.415L19.585,12.5H1a1,1,0,0,1,0-2H19.585L10.793,1.706A1,1,0,0,1,12.206.293l10.5,10.5a1,1,0,0,1,.184.252h0l.01.02v0l.009.018,0,0,.008.017,0,.006.006.015,0,.009,0,.013,0,.011,0,.011,0,.013,0,.009,0,.014,0,.009,0,.016,0,.007,0,.017,0,.007,0,.017,0,.007,0,.016v.008l0,.016v.008l0,.015v.01l0,.014s0,.008,0,.013,0,.007,0,.011v.024c0,.006,0,.012,0,.018s0,0,0,.006,0,.015,0,.022v0c0,.008,0,.017,0,.025h0s0,.009,0,.014,0,.006,0,.01a1,1,0,0,1-.314.7l-10.48,10.48a1,1,0,0,1-1.413,0Z"/>
      </svg>
      </div>
              </div>
            </div>
          </div>
        </router-link>
      </li>
    </ul>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data: () => ({
    loading: true
  }),
  props: {
    list: {
      type: Array,
      default: () => []
    },
    lang: {
      type: String,
      required: true
    },
    background: {
      type: Boolean,
      default: false
    },
    description: {
      type: Boolean,
      default: true
    },
    gallery: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'processingsExcerpts',
      'touch'
    ]),
    hydratedListing: {
      get () {
        return this.processingsExcerpts(this.lang)
      }
    },
    imgServer: {
      get () {
        return process.env.VUE_APP_ENDPOINT
      }
    }
  },
  methods: {
    ...mapActions([
      'loadProcessingsExcerpts'
    ])
  },
  watch: {
    list: {
      async handler (list) {
        this.loading = true
        await this.loadProcessingsExcerpts({
          lang: this.lang,
          filter: list
        })
        this.loading = false
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";
  @import "../assets/mixins/common";

  .listing-come-funziona {
    background-color: #FFF;
    ul, li{
      padding: 0; margin: 0;
      list-style: none; list-style-type: none;
    }
    li{
      overflow: hidden;
      .default-container{
        height: 100%;
      }
      picture{
        position: absolute;
        left: 50%; top: 50%;
        width: 100%; height: auto;
        transform: translate3d(-50%, -50%, 0);
        img{
          width: 100%; height: auto;
        }
      }
      a{
        text-decoration: none;
        display: block;
      }
    }
    li .listing-come-funziona__text-container{
      display: flex; width: 100%; height: 100%;
      align-items: center; flex-wrap: nowrap;
      justify-content: flex-start;

      min-height: 140px;
      @media #{$medium_mq} {
        min-height: 280px;
      }
      @media #{$large_mq} {
        min-height: 320px;
      }

      .number{
        height: 80px;
        width: auto;
        padding-right: 30px;
        @media #{$medium_mq} {
          height: 90px;
        }
        @media #{$large_mq} {
          height: 110px;
        }
        @media #{$morelarge_mq} {
          height: 140px;
        }
        @media #{$xlarge_mq} {
          height: 170px;
        }
        @media #{$xxlarge_mq} {
          height: 202px;
        }
      }

      div:not(.arrow-list-wrapper){
        padding: 5px 0 0 25px;
        @media #{$medium_mq} {
          padding: 5px 0 0 50px;
        }
        @media #{$small_mq} {
          display: flex;
          align-items: center;
        }
        h3{
          font-size: 1rem;
          line-height: 1.3;
          letter-spacing: .05rem;
          color: #343434;
          font-family: 'IBM Plex Mono', sans-serif;
          font-weight: 700;
          transition: color 400ms cubic-bezier(0.23, 1, 0.32, 1);
          br{
            display: none;
          }
        }
        p{
          font-size: 1.25rem;
          line-height: 1.4;
          color: #343434;
          font-family: 'IBM Plex Mono', sans-serif;
          font-weight: 400;
          display: none;
          transition: color 400ms cubic-bezier(0.23, 1, 0.32, 1);
          @media #{$medium_mq} {
            display: block;
          }
          br{
            display: none;
            @media #{$medium_mq} {
              display: block;
            }
          }
        }
      }
    }

    li:hover .listing-come-funziona__text-container{
      .number{
        filter: invert(150%) brightness(1.75);
      }
      div{
        h3 {
          color: #FFF;
        }
        p {
          color: #FFF;
        }
      }
        .arrow-list-wrapper {
          svg {
            fill: #fff;
          }
      }
    }

    li .velina-come-funziona{
      content: "";
      position: absolute;
      left:0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 1);
      transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);
      img{
        height: 100%; width: auto;
        transform: translate3d(-100%, 0, 0);
        transition: all 0 cubic-bezier(0.23, 1, 0.32, 1);
        transition-delay: 0;
      }
    }
  }

  .listing-come-funziona--noTouch li:hover .velina-come-funziona{
    background-color: rgba(255, 255, 255, 0);
    img{
      transform: translate3d(0, 0, 0);
      transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);
      transition-delay: .1s;
    }
  }
  .arrow-list-wrapper {
    display: flex;
    align-items: center;
    padding-left: 15px;

    svg {
      fill: #343434;
      width: 15px;
    }
}
</style>
